import clsx from 'clsx';

import { Alert } from '@@/Alert';
import { Link } from '@@/Link';
import { LinkButton } from '@@/LinkButton';

import { getPolicyTypeDisplayName, PolicyType } from '../types';
import { useCanManagePolicies } from '../utils/useCanManagePolicies';

export type Props = {
  policyName: string;
  policyId: number;
  policyType: PolicyType;
  className?: string;
};

export function PolicyOverrideAlert({
  policyName,
  policyId,
  policyType,
  className,
}: Props) {
  const canManagePolicies = useCanManagePolicies();
  const policyCategory = getPolicyTypeDisplayName(policyType);

  return (
    <Alert
      color="default"
      className={clsx('flex-1', className)}
      title={`Managed by ${policyCategory} Policy`}
    >
      {canManagePolicies ? (
        <div className="inline-flex gap-2 flex-wrap items-center">
          <span>
            These settings are managed by the policy{' '}
            <Link
              to="portainer.policy"
              params={{ id: policyId, tab: 'config' }}
              data-cy="policy-name-link"
              className="text-inherit hover:text-inherit underline"
            >
              {policyName}
            </Link>{' '}
            and cannot be modified here.{' '}
          </span>
          <LinkButton
            to="portainer.policy"
            params={{ id: policyId, tab: 'config' }}
            data-cy="view-policy-link"
            className="w-fit h-fit"
            size="small"
            color="light"
          >
            Manage &apos;{policyName}&apos;
          </LinkButton>
        </div>
      ) : (
        <p>
          These settings are managed by the policy{' '}
          <strong>&apos;{policyName}&apos;</strong> and cannot be modified here.
          Contact your administrator to update{' '}
          <strong>&apos;{policyName}&apos;</strong>.
        </p>
      )}
    </Alert>
  );
}
